/*
 * @Author: ZhangYao
 * @Date: 2021-06-24 20:22:50
 */
import { Store } from 'vuex'
import { StateType } from '../../types'
import { updateSpaceItem } from '/@/api/material/materialModel'

export default {
  async setSpaceItem(store: Store<StateType>, item: CShareDiskNS.ShareSpaceItem | null) {
    store.commit('setSpaceItem', item)
  },
  async setTmpToken(store: Store<StateType>, item: CShareDiskNS.tmpToken | null) {
    store.commit('setTmpToken', item)
  },
  async updateSpaceSize(store: Store<StateType>, item: updateSpaceItem | null) {
    store.commit('updateSpaceSize', item)
  },
  async setShowUploadList(store: Store<StateType>, condition: boolean) {
    store.commit('setShowUploadList', condition)
  },
  async setNoUpload(store: Store<StateType>, condition: boolean) {
    store.commit('setNoUpload', condition)
  },
  async setBatchDown(store: Store<StateType>, condition: boolean) {
    store.commit('setBatchDown', condition)
  },
  async selectedRow(store: Store<StateType>, item: CShareDiskNS.SelectItem) {
    store.commit('setSelectRow', item)
  },
  async onload(context: Store<StateType>, item: any) {
    try {
      if (item != null && item.length > 0) {
        context.commit('setSpaceId', item[0].space_id)
        context.commit('setSpaceItem', item[0])
      }
    } catch (error) {
      console.log('=====onload err======', error)
    }
  },
}
